// external
import React, { FC } from 'react';
import { Button, Typography } from '@mui/material';

// internal
import './coe-empty-state.component.css';

interface COEEmptyStateProps {
  title: string;
  icon: React.ReactNode;
  description: string;
  primaryActionTitle: string;
  primaryAction: () => void;
}

const COEEmptyState: FC<COEEmptyStateProps> = (props) => {

  return (
    <div className='coe-empty-state'>
      <div className='state-icon'>{props.icon}</div>
      <Typography className='text-title'>{props.title}</Typography>
      <Typography className='text-description'>{props.description}</Typography>
      <Button 
        className='primary-button' 
        variant='contained' 
        onClick={props.primaryAction}>{props.primaryActionTitle}
      </Button>
    </div>
  );
};

export default COEEmptyState;